import script from "./BlackUChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackUChecker.vue?vue&type=script&setup=true&lang=js"

import "./BlackUChecker.vue?vue&type=style&index=0&id=10deee37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10deee37"]])

export default __exports__